module.exports = __webpack_public_path__ + "static/kpmg-logo-4bcd058fde0c80fad899266ba50e2931.png";